import { Css, FullBleed, ScrollableContent, TabContent, Tabs } from "@homebound/beam";
import { useState } from "react";
import { useParams } from "react-router";
import { ProjectParams } from "src/routes/routesDef";
import { createBudgetMetricsUrl } from "src/RouteUrls";
import { ProjectHeader } from "../ProjectHeader";
import { BudgetOverviewTab } from "./components/reports/BudgetOverviewTab";
import { CommittedAtStartTab } from "./components/reports/CommittedAtStartTab";
import { DirectMarginTab } from "./components/reports/DirectMarginTab";
import { VarianceTab } from "./components/reports/VarianceTab";

enum BudgetMetricsPageTab {
  Overview = "Budget Metrics",
  DirectMargin = "Direct Margin Per Project",
  Variance = "Average Variance % per Project",
  CommittedAtStart = "Committed at Start",
}

export function BudgetMetricsPage() {
  const { projectId } = useParams<ProjectParams>();
  const [selectedTab, setSelectedTab] = useState<BudgetMetricsPageTab>(BudgetMetricsPageTab.Overview);
  const tabs = [
    { name: "Overview", value: BudgetMetricsPageTab.Overview, render: () => <BudgetOverviewTab /> },
    { name: "Direct Margin", value: BudgetMetricsPageTab.DirectMargin, render: () => <DirectMarginTab /> },
    { name: "Variance %", value: BudgetMetricsPageTab.Variance, render: () => <VarianceTab /> },
    { name: "Committed at Start", value: BudgetMetricsPageTab.CommittedAtStart, render: () => <CommittedAtStartTab /> },
  ];

  return (
    <ScrollableContent>
      <FullBleed>
        <div css={Css.bgWhite.$}>
          <ProjectHeader
            projectId={projectId}
            title={selectedTab}
            createUrl={createBudgetMetricsUrl}
            xss={Css.bn.mb0.$}
          />
          <Tabs tabs={tabs} onChange={setSelectedTab} selected={selectedTab} />
        </div>
      </FullBleed>
      {/*  `overflow-x: hidden` added to prevent flickering when tooltips are rendered by the charts */}
      <TabContent tabs={tabs} selected={selectedTab} contentXss={Css.p3.overflowX("hidden").$} />
    </ScrollableContent>
  );
}
